import { quadrature } from './quadrature';
import { fftDirectDimension, } from './util/fft2d/fftDirectDimension';
import { fftIndirectDimension, } from './util/fft2d/fftIndirectDimension';
import { getMinMaxXY } from './util/getMinMaxXY';
export function xyzBidimensionalFFT(data, options) {
    ensureData2DFid(data);
    const { info, fnMode, digitalFilterValue = 0, zeroFilling: zeroFillingGeneral, } = options;
    const orderedData = quadrature(data, { fnMode });
    const { re: reData } = orderedData;
    const nbRows = reData.length;
    const nbColumns = reData[0].length;
    const { direct = {}, indirect = {} } = options;
    const { zeroFilling: zeroFillingF2 = zeroFillingGeneral } = direct;
    const { factor: f2Factor = 2 } = zeroFillingF2 || {};
    const nbPointsF2 = zeroFillingF2?.nbPoints || 2 ** Math.round(Math.log2(nbColumns * f2Factor));
    const transformed = fftDirectDimension(orderedData, {
        ...direct,
        fnMode,
        digitalFilterValue,
        zeroFilling: { nbPoints: nbPointsF2 },
    });
    const { zeroFilling: zeroFillingF1 } = options;
    const { factor: f1Factor = 2 } = zeroFillingF1 || {};
    const nbPointsF1 = zeroFillingF1?.nbPoints || 2 ** Math.round(Math.log2(nbRows * f1Factor));
    const { re: reResult, im: imResult } = fftIndirectDimension(transformed, {
        ...indirect,
        fnMode,
        zeroFilling: { nbPoints: nbPointsF1 },
    });
    const minMaxXY = getMinMaxXY(info);
    return {
        re: {
            z: convertToDoubleArray(reResult),
            maxZ: reResult.max(),
            minZ: reResult.min(),
            ...minMaxXY,
        },
        im: {
            z: convertToDoubleArray(imResult),
            maxZ: imResult.max(),
            minZ: imResult.min(),
            ...minMaxXY,
        },
    };
}
function ensureData2DFid(data) {
    if (!('re' in data)) {
        throw new Error('bidimensional FFT only can be applied to raw data');
    }
}
function convertToDoubleArray(data) {
    const result = new Array(data.rows);
    for (let i = 0; i < data.rows; i++) {
        result[i] = new Float64Array(data.getRow(i));
    }
    return result;
}
//# sourceMappingURL=xyzBidimensionalFFT.js.map